export default "__VITE_ASSET__Bq$yr1Eb__"